import React, { useState } from 'react'
import {
    Flex,
    Text,
    Grid,
    GridItem,
    Image,
    FormControl,
    FormLabel,
    Input,
    Checkbox,
    Button,
    Link
} from '@chakra-ui/react';
import { toast } from 'react-toastify';
import { trackEvent, trackFacebookEvent } from '../utils/analytics';

const Contacto = () => {
    const [name, setName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [optIn, setOptIn] = useState(false);

    const assets = [
        { imgUrl: 'https://boomerang.s3.us-east-2.amazonaws.com/landings/tecnosur/contact.webp' }
    ];

    const postForm = () => {
        let data_send = {
            fields: [
                {
                    name: "firstname",
                    value: name,
                },
                {
                    name: "lastname",
                    value: lastName,
                },
                {
                    name: "email",
                    value: email,
                },
                {
                    name: "phone",
                    value: phone,
                },
                {
                    name: "whatsapp_opt_in",
                    value: optIn,
                }
            ],
            context: {
                ipAddress: "3.14.97.137",
                pageUri: "www.grupoguia.mx/tecnosur",
                pageName: "Grupo Guia | Tecnosur",
            },
        };
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data_send),
        };
        fetch(
            "https://api.hsforms.com/submissions/v3/integration/submit/5930840/376c0c7a-7245-4082-9128-c630dbf59b07",
            requestOptions
        )
            .then((response) => response.json())
            .then((data_w) => {
                trackEvent('formulario_contacto');
                trackFacebookEvent('Lead', { content_name: 'contacto' });
                toast.success("¡Tus datos fueron eviados correctamente!", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                setName("");
                setLastName("");
                setEmail("");
                setPhone("");
            });
    }

    return (
        <Flex
            marginTop={"4rem"}
            flexDirection={"column"}
            color={"#545454"}
            mb={20}
            id='contacto'
        >
            <Grid
                templateColumns={{ base: "repeat(2, 1fr)", md: "repeat(2, 1fr)" }}
                px={0}
                w={"80%"}
                margin="auto"
                pb={10}
                gap="3em 1em"
                fontWeight={600}
            >
                <GridItem w="100%" id='img'>
                    <Flex height={"100%"} justifyContent={"center"} alignItems={"center"}>
                        <Image src={assets[0].imgUrl} width="500" height="500" alt='icon' />
                    </Flex>
                </GridItem>
                <GridItem id='form'>
                    <Flex flexDirection={"column"} pl={10}>
                        <Text
                            fontSize={'40px'}
                            color={'#0F312C'}
                            fontFamily='Shne-Breit-Regular'
                        >
                            TECNOSUR
                        </Text>
                        <Text
                            fontSize="18px"
                            fontFamily='Shne-Breit-Extraleicht'
                            lineHeight={'27.6px'}
                            color={"#545454"}
                            mt={1}
                            textAlign={{ base: "center", lg: "left" }}
                        >
                            Compártenos tus datos y descubre más sobre Tecnosur.
                        </Text>
                        <Flex
                            justifyContent={"left"}
                            id="contacto"
                            mt={8}
                            width={'100%'}
                            fontFamily='Shne-Breit-Regular'
                        >
                            <form onSubmit={(e) => {
                                e.preventDefault();
                                postForm();
                            }}>
                                <Grid templateColumns={"repeat(2, 1fr)"} width='100%' maxW={'5xl'} mx='auto' gap={10} >
                                    <GridItem colSpan={2}>
                                        <FormControl isRequired>
                                            <FormLabel>Nombre</FormLabel>
                                            <Input
                                                variant='flushed'
                                                value={name}
                                                htmlSize={'100'}
                                                onChange={(e) => setName(e.target.value)}
                                                isRequired
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem colSpan={2}>
                                        <FormControl isRequired>
                                            <FormLabel>Apellido</FormLabel>
                                            <Input
                                                variant='flushed'
                                                value={lastName}
                                                onChange={(e) => setLastName(e.target.value)}
                                                isRequired
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem colSpan={1}>
                                        <FormControl isRequired>
                                            <FormLabel>Número de teléfono</FormLabel>
                                            <Input
                                                variant='flushed'
                                                type='number'
                                                value={phone}
                                                minLength={10}
                                                onChange={(e) => setPhone(e.target.value)}
                                                isRequired
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem colSpan={1}>
                                        <FormControl isRequired>
                                            <FormLabel>Correo</FormLabel>
                                            <Input
                                                variant='flushed'
                                                width={'100%'}
                                                type='email'
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                isRequired
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem colSpan={2} textAlign={'left'}>
                                        <FormControl mb={3}>
                                            <Checkbox
                                                onChange={(e) => {
                                                    e.preventDefault();
                                                    setOptIn(e.target.checked);
                                                }}
                                            >
                                                Acepto ser contactado vía Whatsapp para recibir la información que solicité y continuar con mi proceso de compra.
                                            </Checkbox>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem colSpan={2} textAlign={'left'}>
                                        <Flex fontFamily='Shne-Breit-Extraleicht'>
                                            <Checkbox mr={2} />
                                            <Text>
                                                He leído y acepto el
                                                <Link
                                                    href='https://grupoguia.mx/Aviso-de-privacidad'
                                                    color='blue'
                                                    textDecoration={'underline'}
                                                    ml={2}
                                                    isExternal
                                                >
                                                    Aviso de privacidad
                                                </Link>
                                            </Text>
                                        </Flex>
                                    </GridItem>

                                    <GridItem colSpan={2} textAlign={'left'}>
                                        <Button
                                            type='submit'
                                            color='#000000'
                                            bg='rgba(172, 255, 197, 1)'
                                            _hover={{
                                                bg: '#7CB48D'
                                            }}
                                            fontWeight='400'
                                            px={8}
                                            rounded={'none'}
                                        >
                                            Enviar
                                        </Button>
                                    </GridItem>
                                </Grid>
                            </form>
                        </Flex>
                    </Flex>
                </GridItem>
            </Grid>
        </Flex>
    )
}

export default Contacto

